import * as React from 'react';

export function SvgTrello(props: any) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1223 2H4.87765C3.56464 2 2.5 3.06464 2.5 4.37765V19.6223C2.5 20.9354 3.56464 22 4.87765 22H20.1223C21.4354 22 22.5 20.9354 22.5 19.6223V4.37765C22.5 3.06464 21.4354 2 20.1223 2ZM11.1152 16.4051C11.1152 16.8418 10.7614 17.195 10.3253 17.195H6.9824C6.54575 17.195 6.19251 16.8412 6.19251 16.4051V6.4824C6.19251 6.04575 6.54636 5.69251 6.9824 5.69251H10.3253C10.762 5.69251 11.1152 6.04636 11.1152 6.4824V16.4051ZM18.8075 11.8497C18.8075 12.2864 18.4536 12.6396 18.0176 12.6396H14.6747C14.238 12.6396 13.8848 12.2858 13.8848 11.8497V6.4824C13.8848 6.04575 14.2386 5.69251 14.6747 5.69251H18.0176C18.4543 5.69251 18.8075 6.04636 18.8075 6.4824V11.8497Z"
        fill="#1868db"
      />
    </svg>
  );
}
